const state = {
    produceInformationPackageFields: [
        {
            key: "productCode",
            label: "料號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "specification",
            label: "規格",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "thousand_weight",
            label: "千支重(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "product_description",
            label: "產品說明",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    produceInformationPackageItem: [
        {
            // productCode: "FSBD035M52D2602PAW21AO0X*",
            // specification: "M10~1.5*3.5mm",
            // thousand_weight: "29.25",
            // product_description: "DIN 912 內六角孔螺栓(無直紋) 8.8 粗牙半牙 M4-0.7X16mm (無記號) 調質+鍍鋅 5um+三價鉻+氫脆烘0小時+8小時白鏽+24小時紅鏽 ASTM F1941",
        }
    ],
}
const getters = {
    get_produceInformationPackageFields: state => {
        return state.produceInformationPackageFields
    },
    get_produceInformationPackageItem: state => {
        return state.produceInformationPackageItem
    },
}
const actions = {
    set_produceInformationPackageFields(context, array) {
        context.commit('SET_PRODUCEINFORMATIONPACKAGEFIELDS', array);
    },
    set_produceInformationPackageItem(context, array) {
        context.commit('SET_PRODUCEINFORMATIONPACKAGEITEM', array);
    },
    clear_produceInformationPackageItem(context) {
        context.commit('CLEAR_PRODUCEINFORMATIONPACKAGEITEM');
    },
}
const mutations = {
    SET_PRODUCEINFORMATIONPACKAGEFIELDS(state, array) {
        state.produceInformationPackageFields = array;
    },
    SET_PRODUCEINFORMATIONPACKAGEITEM(state, array) {
        state.produceInformationPackageItem = array;
    },
    CLEAR_PRODUCEINFORMATIONPACKAGEITEM(state) {
        state.produceInformationPackageItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/produceInformationPackage.js